import { render, staticRenderFns } from "./systemGlobal.vue?vue&type=template&id=3db266e7&scoped=true&"
import script from "./systemGlobal.vue?vue&type=script&lang=js&"
export * from "./systemGlobal.vue?vue&type=script&lang=js&"
import style0 from "./systemGlobal.vue?vue&type=style&index=0&id=3db266e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db266e7",
  null
  
)

export default component.exports